import i18n from '@/plugins/i18n'
import { isValidNumber, parsePhoneNumber } from 'libphonenumber-js'
import helpers from '@/helpers'

// Domain allows Unicode letters/digits so internationalized domains
// (e.g. info@strømx.dk) pass; the local part stays ASCII since our email
// provider (AWS SES) doesn't support non-ASCII local parts.
const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[\p{L}\p{N}-]+(?:\.[\p{L}\p{N}-]+)*$/u
const TIME_REGEX = /([0-1][0-9]|2[0-3]):([0-5][0-9])/

export default {
  required: (value) => !!value || i18n.t('error_required'),
  legalAccepted: (value) => !!value || i18n.t('error_consent_missing'),
  // password policy: > 8 chars, +1 lowercase, +1 uppercase
  pwd: (value) => {
    if (!value) {
      return true
    }
    if (value.length < 8) {
      return i18n.t('pwd_rule_length')
    }
    const pwdPattern = /(?=.*[a-z])(?=.*[A-Z])/
    return pwdPattern.test(value) || i18n.t('pwd_rule_format')
  },
  email: (value) => {
    return EMAIL_REGEX.test(value) || i18n.t('error_invalid_email')
  },
  phone: (value) => {
    if (!isValidNumber(value)) {
      return i18n.t('signup_phone_error')
    }

    try {
      const phoneNumber = parsePhoneNumber(value)
      const country = phoneNumber.country.toLowerCase()

      return (
        helpers.isCountrySupported(country) || i18n.t('g_unsupported_country')
      )
    } catch (error) {
      return i18n.t('signup_phone_error')
    }
  },
  identifier: (value) => {
    // an identifier should be a valid email or phone number
    const condition = EMAIL_REGEX.test(value) || isValidNumber(value)
    return condition || i18n.t('invalid_identifier')
  },
  noOnlySpaces: v => v === '' || v.trim().length > 0 || i18n.t('cost_center_name_empty_error'),
  isValidTime: (value) => {
    if (!value) {
      return true
    }
    return TIME_REGEX.test(value) || i18n.t('wrong_time_format')
  },
  // GLN is a GS1 standard identifier: exactly 13 digits, no prefix/whitespace
  gln: (value) => {
    if (!value) {
      return true
    }
    return /^\d{13}$/.test(value) || i18n.t('error_invalid_gln')
  },
  // Invoice partners (Intrum) reject invoices whose postal code is empty, so
  // require at least one digit — values like "-" or " " would otherwise pass
  // `required` and get stripped to an empty string before reaching the backend
  postalCode: (value) => {
    if (!value) {
      return true
    }
    return /\d/.test(value) || i18n.t('error_invalid_postal_code')
  },
}
